









import Vue from 'vue'
import axios from 'axios'
import Component from 'vue-class-component'
import EmailTemplateForm from '../components/Form.vue'

@Component({
  components: {
    EmailTemplateForm,
  }
})
export default class EmailTemplateCreatePage extends Vue {
  breadcrumbs = [
    { url: '/admin/emails/templates', text: 'Email Templates' },
    { text: 'Edit' }
  ]

  errors: { code: string }[] = []

  loading = false

  template = null

  mounted() {
    this.loading = true
    axios.get(`/emails/templates/${this.$route.params.id}`).then(({ data }) => {
      this.template = data
      setTimeout(() => {
        this.loading = false
      } , 500)
    })
  }

  async updateTemplate(data: any) {
    this.errors = []
    try {
      await axios.put(`/emails/templates/${(this.template || { id: 0 }).id}`, data)
      this.$store.dispatch('showSuccess', 'Template updated successfully')
      this.$router.push('/admin/emails/templates')
    } catch (err) {
      if (err.response) {
        if (err.response.data.code && err.response.data.code === 'NAME_TAKEN') {
          this.errors.push({ code: 'NAME_TAKEN' })
        }

        if (!err.response.data.code) {
          this.$store.dispatch('showError', `Error creating template: ${err.response.data.message}`)
        }
      } else {
        this.$store.dispatch('showError', 'Error creating template')
      }
    }
  }
}
